<template>
  <div class="modal" id="deleteModal" tabindex="-1" aria-labelledby="deleteModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="deleteModalLabel">削除確認</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="close"></button>
        </div>
        <div class="modal-body">
          本当に削除しますか？
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="close">キャンセル</button>
          <button type="button" class="btn btn-danger" @click="confirmDelete" data-bs-dismiss="modal">削除</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['paramsId'],
  emits: ['confirmDelete', 'close'],
  methods: {
    confirmDelete() {
      this.$emit('confirmDelete', this.paramsId);
    },
    close() {
      this.$emit('close');
    }
  }
}
</script>
